const profile = {
  "Change your avatar": "Changez votre avatar",
  "Cancel": "Annuler",
};

export default profile;
